import React from 'react';
import { Search, Filter, RotateCcw } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { QUICK, quickRange } from './vpUtils';

const Pick = ({ value, onChange, placeholder, options, testId }) => (
  <Select value={value || 'all'} onValueChange={(v) => onChange(v === 'all' ? '' : v)}>
    <SelectTrigger className="h-9 w-44 bg-white" data-testid={testId}><SelectValue placeholder={placeholder} /></SelectTrigger>
    <SelectContent>
      <SelectItem value="all">{placeholder}</SelectItem>
      {options.map(([v, l]) => <SelectItem key={v} value={v}>{l}</SelectItem>)}
    </SelectContent>
  </Select>
);

export const VPFilters = ({ draft, setDraft, vendors, onApply, onReset }) => {
  const set = (k, v) => setDraft((d) => ({ ...d, [k]: v }));
  const quick = (k) => setDraft((d) => ({ ...d, quick: k, ...(quickRange(k) || {}) }));
  return (
    <div className="space-y-3 rounded-xl border border-slate-200 bg-white p-4" data-testid="vp-filters">
      <div className="flex flex-wrap items-end gap-2">
        <div className="flex flex-wrap gap-1" data-testid="vp-quick-filters">
          {QUICK.map(([k, l]) => (
            <button key={k} type="button" onClick={() => quick(k)} data-testid={`vp-quick-${k}`}
              className={`rounded-full border px-3 py-1.5 text-xs font-medium transition-colors ${draft.quick === k ? 'border-slate-900 bg-slate-900 text-white' : 'border-slate-200 text-slate-600 hover:bg-slate-100'}`}>{l}</button>
          ))}
        </div>
        <label className="text-xs text-slate-500">From<Input type="date" className="h-9 w-40" value={draft.date_from} onChange={(e) => setDraft((d) => ({ ...d, quick: 'custom', date_from: e.target.value }))} data-testid="vp-date-from" /></label>
        <label className="text-xs text-slate-500">To<Input type="date" className="h-9 w-40" value={draft.date_to} onChange={(e) => setDraft((d) => ({ ...d, quick: 'custom', date_to: e.target.value }))} data-testid="vp-date-to" /></label>
      </div>
      <div className="flex flex-wrap items-center gap-2">
        <div className="relative min-w-[260px] flex-1">
          <Search className="absolute left-3 top-2.5 h-4 w-4 text-slate-400" />
          <Input className="h-9 pl-9" placeholder="Supplier invoice no., GRN no., vendor name or vendor ID" value={draft.search}
            onChange={(e) => set('search', e.target.value)} onKeyDown={(e) => e.key === 'Enter' && onApply()} data-testid="vp-search" />
        </div>
        <Pick value={draft.vendor_id} onChange={(v) => set('vendor_id', v)} placeholder="All Vendors" testId="vp-vendor-filter"
          options={vendors.map((v) => [v.vendor_id, v.vendor_name])} />
        <Pick value={draft.payment_status} onChange={(v) => set('payment_status', v)} placeholder="All Payment Status" testId="vp-status-filter"
          options={[['fully_paid', 'Paid'], ['partially_paid', 'Partial'], ['pending', 'Pending']]} />
        <Pick value={draft.payment_type} onChange={(v) => set('payment_type', v)} placeholder="All Payment Types" testId="vp-type-filter"
          options={[['paid', 'Paid (PO terms)'], ['credit', 'Credit (PO terms)'], ['not_set', 'Not set']]} />
        <Pick value={draft.bucket} onChange={(v) => set('bucket', v)} placeholder="All Ageing" testId="vp-bucket-filter"
          options={[['0-30', '0–30 Days'], ['31-60', '31–60 Days'], ['61-90', '61–90 Days'], ['90+', 'Above 90 Days'], ['overdue', 'Overdue only']]} />
        <Button onClick={onApply} className="h-9 gap-1.5 bg-blue-600 hover:bg-blue-700" data-testid="vp-apply"><Filter className="h-4 w-4" />Apply</Button>
        <Button variant="outline" onClick={onReset} className="h-9" title="Reset filters" data-testid="vp-reset"><RotateCcw className="h-4 w-4" /></Button>
      </div>
    </div>
  );
};
